<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari nama pengguna atau ID transaksi&hellip;"
                 aria-label="Cari langganan store" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <select class="vl-select" aria-label="Filter platform"
                  (change)="isPlatform = $event.target.value; applyFilter()">
            <option value="">Semua platform</option>
            <option value="android">Play Store</option>
            <option value="ios">App Store</option>
          </select>
          <select class="vl-select" aria-label="Filter paket"
                  (change)="isType = $event.target.value; applyFilter()">
            <option value="">Semua paket</option>
            <option value="monthly">Bulanan</option>
            <option value="sixmonthly">6 Bulan</option>
            <option value="yearly">Tahunan</option>
          </select>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Pengguna</th>
                  <th>ID Transaksi</th>
                  <th>Platform</th>
                  <th>Paket</th>
                  <th class="text-right">Harga</th>
                  <th>Mulai</th>
                  <th>Berakhir</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let v of isData; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
                  <th class="vl-num">{{rowNo(i)}}</th>
                  <td><span class="vl-name" [innerHTML]="highlight(v.userName)"></span></td>
                  <td>
                    <span class="vl-code-wrap" *ngIf="v.transaction_id">
                      <code class="vl-code vl-trx" [innerHTML]="highlight(v.transaction_id)"></code>
                      <button type="button" class="vl-copy" title="Salin ID transaksi" (click)="copyText(v.transaction_id)">
                        <i class="fa fa-copy"></i></button>
                    </span>
                    <span *ngIf="!v.transaction_id" class="vl-muted">&mdash;</span>
                  </td>
                  <td>
                    <span *ngIf="v.platform == 'android'" class="vl-tag neutral">
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path fill="#00C4FF" d="M3.6 1.9c-.36.2-.6.58-.6 1.05v18.1c0 .47.24.85.6 1.05L13.9 12 3.6 1.9z"/>
                        <path fill="#00E36D" d="M17.2 8.7 5.4 2.2l8.5 8.5 3.3-2z"/>
                        <path fill="#F43249" d="M17.2 15.3 13.9 12.8l-8.5 8.5 11.8-6z"/>
                        <path fill="#FFD400" d="M20.7 10.7l-3.5-2-3.3 3.3 3.3 3.3 3.5-2c1-.57 1-2.03 0-2.6z"/>
                      </svg>
                      Play Store</span>
                    <span *ngIf="v.platform == 'ios'" class="vl-tag neutral">
                      <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#111" d="M16.36 12.76c-.02-2.22 1.81-3.28 1.89-3.33-1.03-1.5-2.63-1.71-3.2-1.73-1.36-.14-2.66.8-3.35.8-.69 0-1.76-.78-2.89-.76-1.49.02-2.86.86-3.62 2.19-1.55 2.68-.4 6.64 1.11 8.81.74 1.06 1.61 2.26 2.76 2.22 1.11-.05 1.53-.72 2.87-.72 1.34 0 1.72.72 2.89.7 1.2-.02 1.95-1.08 2.68-2.15.85-1.23 1.19-2.42 1.21-2.48-.03-.01-2.32-.89-2.35-3.55zM14.16 5.83c.61-.74 1.02-1.77.91-2.8-.88.04-1.94.59-2.57 1.32-.56.65-1.06 1.7-.93 2.7.98.08 1.98-.5 2.59-1.22z"/></svg>
                      App Store</span>
                    <span *ngIf="v.platform != 'android' && v.platform != 'ios'" class="vl-tag neutral">{{v.platformVw}}</span>
                  </td>
                  <td><span class="vl-tag neutral">{{v.typeVw}}</span></td>
                  <td class="text-right">{{v.priceVw}}</td>
                  <td class="vl-muted vl-small">{{v.createdVw}}</td>
                  <td class="vl-muted vl-small">{{v.expiredVw}}</td>
                  <td>
                    <span *ngIf="v.isActive" class="vl-pill on"><span class="vl-dot"></span>Aktif</span>
                    <span *ngIf="!v.isActive" class="vl-pill off"><span class="vl-dot"></span>Berakhir</span>
                  </td>
                </tr>
                <tr *ngIf="!isData.length">
                  <td colspan="9" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> langganan</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
